export default __webpack_public_path__ + "static/media/7.4.b82e679a.jpg";